<template>
    <div>
        <v-dialog v-model="showDialog" @click:outside="closeDialog" persistent max-width="700px">
            <v-card>
                <Loading />
                <v-toolbar dark>
                    <v-spacer></v-spacer>
                    <v-toolbar-title>{{ $t('preferredWayToAddQuestions') }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-container class="text-center">
                    <v-row>
                        <v-col>
                            <v-btn @click="openAiQuestionOption" class="text-capitalize" outlined>{{
                                $t('aiGeneratedQuestions') }}</v-btn>
                        </v-col>
                        <v-col>
                            <v-btn @click="openQuestionAdd" class="text-capitalize" outlined>{{ $t('manualInput')
                            }}</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Loading from '../common/Loading.vue'
export default {
    name: 'QuestionAddDialog',
    components: {
        Loading
    },
    methods: {
        openAiQuestionOption() {
            this.$store.dispatch('dashboard/switchShowQuestionAdd', false)
            this.$store.dispatch('dashboard/switchShowAiQuestionParameter', true)
        },
        closeDialog() {
            this.$store.dispatch('dashboard/switchShowQuestionAdd', false)
        },
        openQuestionAdd() {
            this.$store.dispatch('dashboard/applyLoading')
            this.$store.dispatch('question/fetchSingleQuizTopic', this.$store.getters['question/quiz'].quizTopicId)
                .then(response => {
                    this.$store.dispatch('dashboard/cancelLoading')
                    if (response.status == 200) {
                        this.$store.dispatch('dashboard/switchShowQuestionAdd', false)
                        this.$router.push({ name: 'QuizQuestions' })
                    } else if (response.status == 202) {
                        this.$root.$emit('message_from_parent_long', this.$t(response.data.responseMsg))
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        }
    },
    computed: {
        showDialog() {
            return this.$store.getters['dashboard/showQuestionAddDialog']
        }
    },
    created() {
        if (this.$store.getters['question/quiz'].isRunning) {
            this.$root.$emit('message_from_parent_long', this.$t('liveInterruptionForRunningAssessment'))
        }
    }
}
</script>